import React from "react";
import AppStorage from "../util/AppStorage";
import {Navigate, Route} from "react-router-dom";

function AuthRoute({element}) {
    if (!AppStorage.isUserLoggedIn()) {
        return <Navigate to="/login" replace/>;
    }
    return element;
}

export default AuthRoute;